import React, { useEffect, useState } from "react";
import product from "../../assets/product.png";
import profile from "../../assets/profile.png";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import chat from "../../assets/orders/chat.png";
import {
  Steps,
  Checkbox,
  Modal,
  Radio,
  Space,
  Collapse,
  Carousel,
  message,
} from "antd";
import credit from "../../assets/checkout/credit.png";
import cash from "../../assets/checkout/cash.png";
import note from "../../assets/preview/note.png";
import { useDispatch, useSelector } from "react-redux";
import { updatePreviewFunction } from "../../redux/previewsUpdateSlice";
import previewImage from "../../assets/previewRequests/prev.png";
import calender from "../../assets/calender.png";
import statusIcon from "../../assets/orders/status.png";
import address from "../../assets/orders/address.png";
import desc from "../../assets/orders/desc.png";
import upload from "../../assets/orders/upload.png";
import build from "../../assets/previewRequests/build.png";
import size from "../../assets/previewRequests/size.png";
import door from "../../assets/previewRequests/door.png";
import floors from "../../assets/previewRequests/floors.png";
import { fetchCompanyData } from "../../redux/companyDataSlice";
import { paymentTypeFunction } from "../../redux/paymentTypeSlice";
import { createChatAdmin } from "../../redux/createChatAdminSlice";
import { useTranslation } from "react-i18next";
import { payWalletFunction } from "../../redux/acceptOfferSlice";
import { payNinetyPreviewFunction } from "../../redux/payNinetyPreviewSlice";
import { fetchUser } from "../../redux/getUserSlice";

const GettingReadyPreview = ({
  id,
  date,
  time,
  statuss,
  description,
  addresss,
  area,
  levels_count,
  units_count,
  images,
  construction_type,
  vdate,
  vtime,
  admin_id,
  pre_cost_tax,
  pre_cost_tax_old,
  reason,
  back_tax,
  depositTax,
}) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const [current, setCurrent] = useState(0);
  const [isModalCancel, setIsModalCancel] = useState(false);
  const [isModalView, setIsModalView] = useState(false);

  const dispatch = useDispatch();

  const onChange = (value) => {
    console.log("onChange:", value);
    setCurrent(value);
  };

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const getCurrentStep = () => {
    switch (statuss) {
      case "paid_10":
        return 0;
      case "follow_site":
        return 1;
      case "business_analysis":
        return 2;
      case "cost_assessment":
        return 3;
      default:
        return 0;
    }
  };

  const [isModalOpenDelivery, setIsModalDelivery] = useState(false);

  const showModalDelivery = () => {
    setIsModalDelivery(true);
  };

  const handleOkDelivery = () => {
    setIsModalDelivery(false);
  };

  const handleCancelDelivery = () => {
    setIsModalDelivery(false);
  };

  const showModalView = () => {
    setIsModalView(true);
  };
  const handleOkView = () => {
    setIsModalView(false);
  };
  const handleCancelView = () => {
    setIsModalView(false);
  };

  const showModalCancel = () => {
    setIsModalCancel(true);
  };
  const handleOkCancel = () => {
    setIsModalCancel(false);
  };
  const handleCancelCancel = () => {
    setIsModalCancel(false);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenPrice, setIsModalOpenPrice] = useState(false);
  const [isModalOpenAcceptPrice, setIsModalOpenAcceptPrice] = useState(false);

  const showModalPricing = () => {
    setIsModalOpenPrice(true);
  };

  const handleOkPrice = () => {
    setIsModalOpenPrice(false);
  };

  const handleCancelPrice = () => {
    setIsModalOpenPrice(false);
  };

  const showModalAcceptPrice = () => {
    setIsModalOpenAcceptPrice(true);
  };

  const handleOkAcceptPrice = () => {
    setIsModalOpenAcceptPrice(false);
  };

  const handleCancelAcceptPrice = () => {
    setIsModalOpenAcceptPrice(false);
  };

  const onFinish = (values) => {
    console.log("Form Data:", values);
  };

  const [phone, setPhone] = useState("");
  const [selected, setSelected] = useState("evaluation");

  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

  const [value, setValue] = useState("No reason");

  const [pay, setPay] = useState("visa");

  const onChangePay = (e) => {
    console.log("radio checked", e.target.pay);
    setPay(e.target.value);
  };

  const { status, error } = useSelector((state) => state.paymentType);

  const handleMethod = async (e) => {
    e.preventDefault();

    const payload = {
      order_id: id,
      type: pay,
      wallet_pay: walletPay,
      order_status: "preview",
    };

    try {
      const result = await dispatch(paymentTypeFunction(payload)).unwrap();
      console.log("Payment successful:", result);
    } catch (error) {
      console.error("Payment failed:", error);
    }
  };

  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
    {
      collapsed ? <DownOutlined /> : <UpOutlined />;
    }
  };

  const customExpandIcon = ({ isActive }) =>
    isActive ? (
      <UpOutlined className="plus-icon mt-4" />
    ) : (
      <DownOutlined className="plus-icon mt-4" />
    );

  const items = [
    {
      key: "1",
      label: (
        <>
          <h3 className="text-[#525D71] font-semibold">{t("Order Details")}</h3>
        </>
      ),
      children: (
        <div>
          <div className="px-5">
            <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
              <div className="flex items-center mt-3 ">
                <img
                  src={calender}
                  className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
                />
                <p className="text-[#283D63] font-medium">
                  {date} | {time}
                </p>
              </div>
              <div className="flex items-center mt-3 ">
                <img
                  src={address}
                  className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
                />
                <p className="text-[#283D63] font-medium">{addresss}</p>
              </div>
            </div>

            <div className="flex items-start mt-5 ">
              <img
                src={desc}
                className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
              />
              <p className="text-[#283D63] font-medium">{description}</p>
            </div>

            <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
              <div className="flex items-center mt-3 ">
                <img
                  src={upload}
                  className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
                />
                {images?.uploaded_images?.length > 0 ? (
                  <>
                    <button
                      onClick={showModalView}
                      className="text-[#6682B6] underline font-medium"
                    >
                      {t("View Uploaded Images")}
                    </button>
                    <Modal
                      title={t("Uploaded Images")}
                      className="orderModal orderModalPricing w_small_modal"
                      open={isModalView}
                      onOk={handleOkView}
                      onCancel={handleCancelView}
                      footer={null}
                    >
                      <Carousel
                        arrows
                        infinite={false}
                        className="custome_carousel_images"
                      >
                        {images?.uploaded_images?.map((img, index) => (
                          <div key={index}>
                            <img
                              src={`https://service.samoolah.com/${img}`}
                              alt={`Uploaded image ${index + 1}`}
                              className="w-[120px] mx-auto my-5"
                            />
                          </div>
                        ))}
                      </Carousel>
                    </Modal>
                  </>
                ) : (
                  <p className="text-[#283D63] font-medium">
                    {t("No Uploaded Images")}
                  </p>
                )}
              </div>
              <div className="flex items-center mt-3 ">
                <img
                  src={statusIcon}
                  className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
                />
                <p className="text-[#737E91] font-medium">{t("Status")}</p>
                <p className="text-[#283D63] font-medium ml-2">{statuss}</p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
              <div className="flex items-center mt-3 ">
                <img
                  src={build}
                  className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
                />
                <p className="text-[#737E91] font-medium">
                  {t("Property:")}
                  <span
                    className={`text-[#283D63] ${
                      language == "en" ? "ml-1" : "mr-1"
                    }`}
                  >
                    {construction_type}
                  </span>
                </p>
              </div>
              <div className="flex items-center mt-3 ">
                <img
                  src={size}
                  className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
                />
                <p className="text-[#737E91] font-medium">
                  {t("Area in square meters:")}
                </p>
                <p
                  className={`text-[#283D63] font-medium ${
                    language == "en" ? "ml-2" : "mr-2"
                  }`}
                >
                  {area}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 max-xl:grid-cols-1 items-center">
              <div className="flex items-center mt-3 ">
                <img
                  src={floors}
                  className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
                />
                <p className="text-[#737E91] font-medium">
                  {t("Number of floors:")}
                  <span
                    className={`text-[#283D63] ${
                      language == "en" ? "ml-1" : "mr-1"
                    }`}
                  >
                    {levels_count}
                  </span>
                </p>
              </div>
              <div className="flex items-center mt-3 ">
                <img
                  src={door}
                  className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
                />
                <p className="text-[#737E91] font-medium">
                  {t("Number of apartments:")}
                </p>
                <p className={`text-[#283D63] font-medium ${language == "en" ? "ml-2" : "mr-2"}`}>{units_count}</p>
              </div>
            </div>
          </div>
        </div>
      ),
    },
  ];

  const { companyData, statusComp, errorComp } = useSelector(
    (state) => state.companyData
  );

  console.log(companyData);

  useEffect(() => {
    dispatch(fetchCompanyData(admin_id));
  }, [dispatch]);

  const navigate = useNavigate();

  const { statusChat, errorChat } = useSelector(
    (state) => state.createChatAdmin
  );

  // useEffect(() => {
  //   if (statusChat === "idle") {
  //     dispatch(createChatAdmin());
  //   }
  // }, [dispatch, statusChat]);

  const { getUser } = useSelector((state) => state.getUser);

  useEffect(() => {
    dispatch(fetchUser());
  }, [dispatch]);

  const handleChatLinkClick = () => {
    navigate(`/chatadmin/${admin_id}`);
    dispatch(createChatAdmin());
  };

  const [walletPay, setWalletPay] = useState(0);
  const [walletMoney, setWalletMoney] = useState("");
  const [walletError, setWalletError] = useState("");

  const onChangeWallet = (e) => {
    const checked = e.target.checked;
    console.log("Use my wallet:", checked);
    setWalletPay(checked ? 1 : 0);
    if (!checked) {
      setWalletMoney("");
      setWalletError("");
    }
  };

  const handlePay = async (e) => {
    e.preventDefault();

    const paydata = {
      construction_preview_id: id,
      type: "back_construction",
    };

    const payload = {
      construction_preview_id: id,
    };

    try {
      if (walletPay == 1) {
        const totalWallet = getUser?.total_wallet || 0;
        if (back_tax > totalWallet) {
          setWalletError(
            `${t("Amount exceeds your wallet balance of")} ${totalWallet}`
          );
        } else if (back_tax <= 0) {
          setWalletError(t("Amount must be greater than 0"));
        } else {
          dispatch(payWalletFunction(paydata));
          message.success(t("Payment successful"));
        }
      } else {
        const result = await dispatch(
          payNinetyPreviewFunction(payload)
        ).unwrap();
        console.log(t("Payment response"), result);
        if (result.payment_url) {
          window.open(result.payment_url, "_blank");
        } else {
          console.error(t("Payment URL not found in the response."));
        }
      }
    } catch (error) {
      console.error(t("Payment failed"), error);
    }
  };

  return (
    <div className="Preparing">
      <img src={previewImage} className="w-[120px] mx-auto my-5 rounded-2xl" />
      <div className="text-center">
        <p className="text-[#737E91] font-semibold text-xl">
          {t("Order number")}
          <span className="text-[#283D63] font-semibold">#{id}</span>
        </p>
        <p className="text-[#A6ADB9] mt-2">
          {t("Order created on")} {date} <br /> {time}
        </p>
      </div>

      <Steps
        current={getCurrentStep(statuss)}
        onChange={(currentStep) => {
          if (currentStep !== getCurrentStep(statuss)) {
            return;
          }
        }}
        labelPlacement="vertical"
        className="pt-5 pb-3 w-5/6 mx-auto"
        items={[
          { title: t("Getting ready") },
          { title: t("Team on site") },
          { title: t("Reviewing site") },
          { title: t("Evaluating costs") },
        ]}
      />

      {getCurrentStep(statuss) === 0 && (
        <>
          <div className="bg-[#FCFBFA] rounded-2xl font-medium p-5 mx-auto my-5 flex items-center justify-between">
            <div className="flex items-center">
              <img src={profile} className="w-[48px] mr-3" />
              <p className="text-[#525D71] font-medium text-lg">
                {companyData?.admin?.name}
              </p>
            </div>
            <Link
              to={`/compdetails/${admin_id}`}
              className="bg-[#FE9B71] text-white rounded-full py-2 px-5 flex font-medium"
            >
              {t("View details")}
            </Link>
          </div>

          <div className="bg-[#FCFBFA] rounded-2xl font-medium w-[300px] p-5 mx-auto text-lg my-5">
            <h3 className="text-[#525D71] text-xl"> {t("Scheduled Visit")}</h3>
            <div className="lg:pr-10">
              <div>
                <p className="text-[#A4ADBC] mt-3"> {t("Date")}</p>
                <p className="text-[#FE9B71]">{vdate}</p>
              </div>
              <div>
                <p className="text-[#A4ADBC] mt-3"> {t("Time")}</p>
                <p className="text-[#FE9B71]">{vtime}</p>
              </div>
            </div>
          </div>

          <button
            onClick={handleChatLinkClick}
            className="bg-[#FE9B71] text-white rounded-xl py-2 px-5 flex items-center text-white mb-10 w-[200px] mx-auto"
          >
            <img
              src={chat}
              className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
            />
            <p className="font-medium">
              {" "}
              {t("Chat with")} {companyData?.admin?.name}
            </p>
          </button>

          <Collapse
            defaultActiveKey={["1"]}
            inlineCollapsed={collapsed}
            items={items}
            expandIcon={customExpandIcon}
            expandIconPosition="right"
            bordered={false}
            className="bg-white custom_collapse mt-5"
          />

          <button
            onClick={showModalCancel}
            className="text-[#FE9B71] rounded-full text-lg border-2 border-[#FE9B71] px-10 py-2 mt-10 mb-5 flex mx-auto"
          >
            {t("Cancel Preview")}
          </button>
          <Modal
            title={t("Are you sure you want to cancel?")}
            className="orderModal orderModalPricing w_small_modal"
            open={isModalCancel}
            onOk={handleOkCancel}
            onCancel={handleCancelCancel}
            footer={null}
          >
            <form
              className="mx-5 my-5"
              onSubmit={(e) => {
                e.preventDefault();
                dispatch(
                  updatePreviewFunction({
                    status: "cancelled",
                    construction_preview_id: id,
                    cancel_reason: value,
                  })
                );
                setIsModalCancel(false);
              }}
            >
              <p className="text-[#A6ADB9] text-center">
                {t("No refund is available after team visit")}
              </p>

              <button
                type="submit"
                className="bg-[#FE9B71] text-white rounded-full py-2 px-10 flex mx-auto font-medium text-lg mt-5"
              >
                {t("Cancel Preview")}
              </button>
            </form>
          </Modal>
        </>
      )}

      {getCurrentStep(statuss) === 1 && (
        <>
          <div className="bg-[#FCFBFA] rounded-2xl font-medium p-5 mx-auto my-5 flex items-center justify-between">
            <div className="flex items-center">
              <img src={profile} className={`w-[48px] ${language == "en" ? "mr-3" : "ml-3"}`} />
              <p className="text-[#525D71] font-medium text-lg">
                {companyData?.admin?.name}
              </p>
            </div>
            <Link
              to={`/compdetails/${admin_id}`}
              className="bg-[#FE9B71] text-white rounded-full py-2 px-5 flex font-medium"
            >
              {t("View details")}
            </Link>
          </div>

          <div className="flex items-center justify-between mx-auto bg-[#FCFBFA] rounded-2xl px-7 py-4 my-4 lg:mx-24">
            <div>
              <p className="text-[#525D71] font-medium text-lg">
                 {t("The team has arrived")}
              </p>
              <p className="text-[#A4ADBC] text-lg mt-3">{t("ARR:")}</p>
              <p className="text-[#FE9B71] text-lg">{vtime}</p>
            </div>
            <div>
              <img src={profile} className={`w-[48px] ${language == "en" ? "mr-3" : "ml-3"}`} />
            </div>
          </div>

          <button
            onClick={handleChatLinkClick}
            className="bg-[#FE9B71] text-white rounded-xl py-2 px-5 flex items-center text-white mb-10 w-[200px] mx-auto"
          >
            <img
              src={chat}
              className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
            />
            <p className="font-medium"> {t("Chat with")} {companyData?.admin?.name}</p>
          </button>

          {/* <div className="bg-[#FCFBFA] rounded-2xl flex items-center justify-between font-medium p-5 lg:w-2/3">
            <h3 className="text-[#525D71] text-xl">Order Details</h3>
            <div className="text-[#EAA182]">
              <DownOutlined />
            </div>
          </div> */}

          <Collapse
            defaultActiveKey={["1"]}
            inlineCollapsed={collapsed}
            items={items}
            expandIcon={customExpandIcon}
            expandIconPosition="right"
            bordered={false}
            className="bg-white custom_collapse mt-5"
          />

          <button
            onClick={showModalCancel}
            className="text-[#FE9B71] rounded-full text-lg border-2 border-[#FE9B71] px-10 py-2 mt-10 mb-5 flex mx-auto"
          >
            {t("Cancel Preview")}
          </button>
          <Modal
            title={t("Are you sure you want to cancel?")}
            className="orderModal orderModalPricing w_small_modal"
            open={isModalCancel}
            onOk={handleOkCancel}
            onCancel={handleCancelCancel}
            footer={null}
          >
            <form
              className="mx-5 my-5"
              onSubmit={(e) => {
                e.preventDefault();
                dispatch(
                  updatePreviewFunction({
                    status: "cancelled",
                    construction_preview_id: id,
                    cancel_reason: value,
                  })
                );
                setIsModalCancel(false);
              }}
            >
              <p className="text-[#A6ADB9] text-center">
              {t("No refund is available after team visit")}
              </p>

              <button
                type="submit"
                className="bg-[#FE9B71] text-white rounded-full py-2 px-10 flex mx-auto font-medium text-lg mt-5"
              >
                {t("Cancel Preview")}
              </button>
            </form>
          </Modal>
        </>
      )}

      {getCurrentStep(statuss) === 2 && (
        <>
          <div className="bg-[#FCFBFA] rounded-2xl font-medium p-5 mx-auto my-5 flex items-center justify-between">
            <div className="flex items-center">
              <img src={profile} className={`w-[48px] ${language == "en" ? "mr-3" : "ml-3"}`} />
              <p className="text-[#525D71] font-medium text-lg">
                {companyData?.admin?.name}
              </p>
            </div>
            <Link
              to={`/compdetails/${admin_id}`}
              className="bg-[#FE9B71] text-white rounded-full py-2 px-5 flex font-medium"
            >
              {t("View details")}
            </Link>
          </div>

          <div className="flex items-center justify-between mx-auto bg-[#FCFBFA] rounded-2xl px-7 py-4 my-4 lg:mx-24">
            <div>
              <p className="text-[#525D71] font-medium text-lg">
              {t("The team has arrived")}
              </p>
              <p className="text-[#A4ADBC] text-lg mt-3">{t("ARR:")}</p>
              <p className="text-[#FE9B71] text-lg">{vtime}</p>
            </div>
            <div>
              <img src={profile} className={`w-[48px] ${language == "en" ? "mr-3" : "ml-3"}`} />
            </div>
          </div>

          <button
            onClick={handleChatLinkClick}
            className="bg-[#FE9B71] text-white rounded-xl py-2 px-5 flex items-center text-white mb-10 w-[200px] mx-auto"
          >
            <img
              src={chat}
              className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
            />
            <p className="font-medium">{t("Chat with")} {companyData?.admin?.name}</p>
          </button>

          <Collapse
            defaultActiveKey={["1"]}
            inlineCollapsed={collapsed}
            items={items}
            expandIcon={customExpandIcon}
            expandIconPosition="right"
            bordered={false}
            className="bg-white custom_collapse mt-5"
          />

          <button
            onClick={showModalCancel}
            className="text-[#FE9B71] rounded-full text-lg border-2 border-[#FE9B71] px-10 py-2 mt-10 mb-5 flex mx-auto"
          >
            {t("Cancel Preview")}
          </button>
          <Modal
            title={t("Are you sure you want to cancel?")}
            className="orderModal orderModalPricing w_small_modal"
            open={isModalCancel}
            onOk={handleOkCancel}
            onCancel={handleCancelCancel}
            footer={null}
          >
            <form
              className="mx-5 my-5"
              onSubmit={(e) => {
                e.preventDefault();
                dispatch(
                  updatePreviewFunction({
                    status: "cancelled",
                    construction_preview_id: id,
                    cancel_reason: value,
                  })
                );
                setIsModalCancel(false);
              }}
            >
              <p className="text-[#A6ADB9] text-center">
              {t("No refund is available after team visit")}
              </p>

              <button
                type="submit"
                className="bg-[#FE9B71] text-white rounded-full py-2 px-10 flex mx-auto font-medium text-lg mt-5"
              >
                {t("Cancel Preview")}
              </button>
            </form>
          </Modal>
        </>
      )}

      {getCurrentStep(statuss) === 3 && (
        <>
          <div className="bg-[#FCFBFA] rounded-2xl font-medium p-5 mx-auto my-5 flex items-center justify-between">
            <div className="flex items-center">
              <img src={profile} className={`w-[48px] ${language == "en" ? "mr-3" : "ml-3"}`} />
              <p className="text-[#525D71] font-medium text-lg">
                {companyData?.admin?.name}
              </p>
            </div>
            <Link
              to={`/compdetails/${admin_id}`}
              className="bg-[#FE9B71] text-white rounded-full py-2 px-5 flex font-medium"
            >
              {t("View details")}
            </Link>
          </div>

          <div className="bg-[#FCFBFA] rounded-2xl font-medium w-[300px] p-5 mx-auto text-lg my-5">
            <h3 className="text-[#525D71] text-xl"> {t("Scheduled Visit")}</h3>
            <div className="">
              <div className="lg:pr-10 flex items-center justify-between">
                <div>
                  <p className="text-[#A4ADBC] mt-3"> {t("Old")}</p>
                  <p className="text-[#FE9B71]">{pre_cost_tax_old} {t("SR")}</p>
                </div>
                <div>
                  <p className="text-[#A4ADBC] mt-3">10%</p>
                  <p className="text-[#FE9B71]">-{depositTax} {t("SR")}</p>
                </div>
              </div>
              <div className="lg:pr-10 flex items-center justify-between">
                <div>
                  <p className="text-[#A4ADBC] mt-3">{t("New")}</p>
                  <p className="text-[#FE9B71]">{pre_cost_tax} {t("SR")}</p>
                </div>
                <div>
                  <p className="text-[#A4ADBC] mt-3">{t("New")}</p>
                  <p className="text-[#FE9B71]">{back_tax} {t("SR")}</p>
                </div>
              </div>
            </div>
          </div>

          <button
            onClick={handleChatLinkClick}
            className="bg-[#FE9B71] text-white rounded-xl py-2 px-5 flex items-center text-white mb-10 w-[200px] mx-auto"
          >
            <img
              src={chat}
              className={`w-[28px] ${language == "en" ? "mr-2" : "ml-2"}`}
            />
            <p className="font-medium">{t("Chat with")} {companyData?.admin?.name}</p>
          </button>

          {/* <div>
            <h3 className="text-[#283D63] text-xl">Price Justification</h3>
            <div className="bg-[#F9FBFC] rounded-2xl text-[#A3B9DD] px-5 py-3 my-4 text-lg h-[130px] overflow-auto">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco. Lorem
                ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco quis
                nostrud exercitation ullamco ullamco
              </p>
            </div>
          </div> */}

          <div className="lg:px-32 mb-7">
            <img src={note} className="w-[30px] mx-auto" />
            <p className="text-[#737E91] text-lg mt-4 mx-auto text-center">
              {t("Payment is required to have access to your finalized report")}
            </p>
          </div>

          <h3 className="text-[#14294F] text-xl font-medium">{t("Payment")}</h3>

          <div className="mx-auto">
            <Checkbox
              onChange={onChangeWallet}
              className="text-[#283D63] font-medium text-lg my-4 flex mx-auto justify-center"
            >
               {t("Use my wallet")}
            </Checkbox>
            <div>
              <form onSubmit={handlePay}>
                <div className="">
                  <div className="bg-[#FCFBFA] rounded-2xl">
                    <div className="flex items-center justify-between bg-[#FCFBFA] rounded-2xl px-5 py-4">
                      <Radio.Group
                        onChange={onChangePay}
                        value={pay}
                        className="custome_radio text-lg text-[#525A6B]"
                        disabled={walletPay === 1}
                      >
                        <Space direction="vertical">
                          <Radio value="visa"> {t("CreditDebit Card")}</Radio>
                        </Space>
                      </Radio.Group>
                      <div>
                        <img src={credit} className="w-[30px]" />
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  disabled={status === "loading"}
                  className="bg-[#FE9B71] text-white rounded-full py-3 px-14 mt-7 flex mx-auto font-medium text-lg"
                >
                  {status === "loading" ? t("Processing...") : t("Proceed")}
                </button>
                {error && (
                  <p className="text-red-500 text-center mt-2">{error}</p>
                )}
                {walletError && (
                  <p className="text-red-500 text-center mt-2">{walletError}</p>
                )}
              </form>
            </div>
          </div>

          <Collapse
            defaultActiveKey={["1"]}
            inlineCollapsed={collapsed}
            items={items}
            expandIcon={customExpandIcon}
            expandIconPosition="right"
            bordered={false}
            className="bg-white custom_collapse mt-5"
          />
        </>
      )}
    </div>
  );
};

export default GettingReadyPreview;
